import {
	Button,
	Typography,
	Dialog,
	DialogContent,
	useMediaQuery,
	useTheme,
	Divider,
	DialogActions,
	LinearProgress,
} from '@mui/material'
import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import TransitionEffect from 'components/TransitionEffect'
import {
	DataGridPremium,
	GridDensity,
	koKR,
	GridToolbar,
} from '@mui/x-data-grid-premium'
import { getSettings } from 'helpers/storage'
import { useState } from 'react'

type TatPopupByTestCodeProps = {
	dialogOpen: boolean
	dialogClose: () => void
	tatOverList: TatOverType[]
	loading: boolean
}

type TatOverType = {
	ChartNo: string
	ClientName: string
	DisplayName: string
	ReceptionDate: string
	ReceptionRegNum: string
	TATHours: number
	RItemID: number
	TATCalcHours: number
	PatientName: string
}

const TatPopupByTestCode = ({
	dialogOpen,
	dialogClose,
	tatOverList,
	loading,
}: TatPopupByTestCodeProps) => {
	const env = getSettings()
	const theme = useTheme()
	const isMdUp = useMediaQuery(theme.breakpoints.up('md'))
	const [gridPageSize, setGridPageSize] = useState(env.row ? env.row : 100)
	return (
		<Dialog
			fullScreen={false}
			open={dialogOpen}
			onClose={dialogClose}
			TransitionComponent={TransitionEffect}
			maxWidth="lg"
			PaperProps={{
				sx: {
					minWidth: '1200px',
				},
			}}
		>
			<AppBar sx={{ position: 'relative' }}>
				<Toolbar variant="dense">
					<Typography
						sx={{ flex: 1 }}
						variant="h6"
						component="div"
					>
						TAT 초과 목록
					</Typography>
					<IconButton
						edge="end"
						color="inherit"
						onClick={dialogClose}
						aria-label="close"
					>
						<CloseIcon />
					</IconButton>
				</Toolbar>
			</AppBar>
			<DialogContent>
				<div style={{ height: '100%', width: '100%' }}>
					<DataGridPremium
						rows={tatOverList}
						loading={loading}
						experimentalFeatures={{ newEditingApi: true }}
						disableMultipleSelection={true}
						autoHeight={true}
						columns={[
							{
								field: 'id',
								headerName: 'RItemID',
								type: 'number',
								width: 150,
							},
							{
								field: 'ReceptionDate',
								headerName: '접수일',
								width: 120,
							},
							{
								field: 'ReceptionRegNum',
								headerName: '접수번호',
								width: 120,
							},
							{
								field: 'PatientName',
								headerName: '수진자명',
								width: 120,
							},
							{
								field: 'ChartNo',
								headerName: '차트번호',
								width: 150,
							},
							{
								field: 'DisplayName',
								headerName: '검사명',
								width: 350,
							},
							{
								field: 'TATHours',
								headerName: 'TAT 시간',
								type: 'number',
								width: 100,
							},
							{
								field: 'TATCalcHours',
								headerName: '실제 계산된 시간',
								type: 'number',
								width: 150,
							},
						]}
						pagination
						pageSize={gridPageSize}
						onPageSizeChange={(newPageSize) => setGridPageSize(newPageSize)}
						localeText={koKR.components.MuiDataGrid.defaultProps.localeText}
						density={(env.desnse as GridDensity) || 'compact'}
						initialState={{
							columns: {
								columnVisibilityModel: {
									id: false,
								},
							},
						}}
						components={{
							Toolbar: GridToolbar,
							LoadingOverlay: LinearProgress,
						}}
						componentsProps={{
							toolbar: {
								csvOptions: { disableToolbarButton: true },
								excelOptions: { disableToolbarButton: true },
								printOptions: { disableToolbarButton: true },
								showQuickFilter: false,
								quickFilterProps: { debounceMs: 250 },
							},
						}}
						sx={{
							'& .MuiDataGrid-columnHeaderTitleContainer': {
								fontSize: '13px',
							},
							'& .MuiDataGrid-cell': {
								fontSize: '13px !important',
								borderRight:
									theme.palette.mode === 'dark'
										? '1px solid rgba(81, 81, 81, 1)'
										: '1px solid rgba(224, 224, 224, 1)',
							},
						}}
					/>
				</div>
			</DialogContent>
			<Divider />
			<DialogActions sx={{ p: 2 }}>
				<Button
					type="button"
					variant="contained"
					onClick={dialogClose}
					color="secondary"
				>
					확인
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default TatPopupByTestCode
